import { useDispatch } from "react-redux";
import { toggleChatWindow } from "@b2bportal/core-self-serve";
import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useChatSupport } from "@hopper-b2b/self-serve";
import styles from "./ContactSupport.module.scss";
import { ActionLine } from "@/overrides/trips";

interface ContactSupportProps {
  onStartChat?: () => void;
  startChat?: () => void | Promise<void>;
}

export const ContactSupport = ({
  onStartChat,
  startChat,
}: ContactSupportProps) => {
  const dispatch = useDispatch();
  const { t, brand } = useI18nContext();
  const { generalSupportChat } = useChatSupport();
  const { displaySupportNumber, supportNumber } = brand.contactSupport;
  const [block, cn] = useModuleBEM(styles, "ContactSupport");

  return (
    <div className={block}>
      <div className={cn("header")}>
        <h3 className={cn("title")}>
          {t("core-self-serve.contactSupport.title")}
        </h3>
        <p className={cn("description")}>
          {t("core-self-serve.contactSupport.description")}
        </p>
      </div>

      <div className={cn("actions")}>
        <div className={cn("action-card")}>
          <ActionLine
            icon={IconNameEnum.customerSupport}
            primaryText={t("core-self-serve.contactSupport.chat")}
            secondaryText={t("core-self-serve.contactSupport.chatSubtitle")}
            onClick={async () => {
              try {
                if (startChat != null) {
                  await startChat();
                } else if (generalSupportChat != null) {
                  await generalSupportChat();
                } else {
                  dispatch(toggleChatWindow());
                }
                onStartChat?.();
              } catch (error) {
                console.error("Failed to start support chat", error);
              }
            }}
          />
        </div>
        <div className={cn("action-card")}>
          <ActionLine
            icon={IconNameEnum.phone}
            content={
              <>
                <div className={cn("call-label")}>
                  <span>{t("core-self-serve.contactSupport.callLabel")}</span>{" "}
                  <span className={cn("call-phone")}>
                    {displaySupportNumber}
                  </span>
                </div>
                <div className={cn("call-subtitle")}>
                  {t("core-self-serve.contactSupport.callSubtitle")}
                </div>
              </>
            }
            onClick={() => (window.location.href = `tel:${supportNumber}`)}
          />
        </div>
      </div>
    </div>
  );
};
